import adminApiClient from '../../api/base/adminApiClient'

export interface PlaceCategory {
  id: number
  code: string
  name: string
  icon_path: string | null
  marker_pin_path: string | null
  marker_pin_bookmarked_path: string | null
  category_icon_brown_path: string | null
  place_count: number
  created_at: string
  updated_at: string
}

export interface GetPlaceCategoriesResponse {
  data: PlaceCategory[]
}

export interface CreatePlaceCategoryParams {
  code: string
  name: string
  icon?: File | null
  marker_pin?: File | null
  marker_pin_bookmarked?: File | null
  category_icon_brown?: File | null
}

export interface UpdatePlaceCategoryParams {
  code: string
  name: string
  icon?: File | null
  marker_pin?: File | null
  marker_pin_bookmarked?: File | null
  category_icon_brown?: File | null
}

export interface CreatePlaceCategoryResponse {
  message: string
  data: PlaceCategory
}

export interface UpdatePlaceCategoryResponse {
  message: string
  data: PlaceCategory
}

export const adminPlaceCategoryApi = {
  getPlaceCategories: async (): Promise<GetPlaceCategoriesResponse> => {
    const response = await adminApiClient.get<GetPlaceCategoriesResponse>(
      '/admin/place-categories'
    )
    return response.data
  },
  createPlaceCategory: async (
    params: CreatePlaceCategoryParams
  ): Promise<CreatePlaceCategoryResponse> => {
    const formData = new FormData()
    formData.append('code', params.code)
    formData.append('name', params.name)
    if (params.icon) {
      formData.append('icon', params.icon)
    }
    if (params.marker_pin) {
      formData.append('marker_pin', params.marker_pin)
    }
    if (params.marker_pin_bookmarked) {
      formData.append('marker_pin_bookmarked', params.marker_pin_bookmarked)
    }
    if (params.category_icon_brown) {
      formData.append('category_icon_brown', params.category_icon_brown)
    }

    const response = await adminApiClient.post<CreatePlaceCategoryResponse>(
      '/admin/place-categories',
      formData
    )
    return response.data
  },
  updatePlaceCategory: async (
    id: number,
    params: UpdatePlaceCategoryParams
  ): Promise<UpdatePlaceCategoryResponse> => {
    const formData = new FormData()
    formData.append('code', params.code)
    formData.append('name', params.name)
    if (params.icon) {
      formData.append('icon', params.icon)
    }
    if (params.marker_pin) {
      formData.append('marker_pin', params.marker_pin)
    }
    if (params.marker_pin_bookmarked) {
      formData.append('marker_pin_bookmarked', params.marker_pin_bookmarked)
    }
    if (params.category_icon_brown) {
      formData.append('category_icon_brown', params.category_icon_brown)
    }

    const response = await adminApiClient.put<UpdatePlaceCategoryResponse>(
      `/admin/place-categories/${id}`,
      formData
    )
    return response.data
  },
  deletePlaceCategory: async (
    id: number
  ): Promise<{ message: string }> => {
    const response = await adminApiClient.delete<{ message: string }>(
      `/admin/place-categories/${id}`
    )
    return response.data
  },
}
